// frontend/src/services/edaPrepare.service.ts

import api from './api';

const BASE_URL = '/eda-prepare';

export class EdaPrepareService {

  static async listSnapshots(): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/snapshots`);
    return response.data.data;
  }

  static async getSnapshot(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/snapshot/analyze/${id}`);
    return response.data.data;
  }

  static async getSnapshotById(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/snapshot/${id}`);
    return response.data.data;
  }

  static async getSnapshotByName(datasetName: string): Promise<any> {
    const response = await api.get(`${BASE_URL}/snapshot/name/${datasetName}`);
    return response.data.data;
  }

  static async getSnapshotsByTraceId(traceId: string): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/snapshot/trace/${traceId}`);
    return response.data.data;
  }

  static async getSummary(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/snapshot/summary/${id}`);
    return response.data.data;
  }
}